
import { puzzleReducer } from 'Redux-Manager/reducers/puzzleReducer';

const appReducers = {
  puzzleReducer,
};

export { appReducers };
